import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, inject, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SettingsComponent } from '../settings/settings.component';
import type { OverlayEventDetail } from '@ionic/core';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonIcon,
  IonButton,
  IonButtons,
  IonItem,
  IonPopover,
  IonList,
  IonLabel,
  IonAvatar,
  IonAlert,
} from '@ionic/angular/standalone';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { UserProfile } from '@app/types/app.types';
import { createAvatar } from '@app/utils/app.utils';
import { AuthService } from '@app/services/auth.service';
import { CustomConaTooltipComponent } from '../custom-cona-tooltip/custom-cona-tooltip.component';
import { OverlayComponent } from '../overlay/overlay.component';
import { SettingsOverlayService } from '@app/services/settings-overlay.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonIcon,
    IonButton,
    IonButtons,
    IonItem,
    IonPopover,
    IonList,
    IonLabel,
    IonAvatar,
    CommonModule,
    IonAlert,
    CustomConaTooltipComponent,
    SettingsComponent,
    OverlayComponent,
  ],
  providers: [ModalController],
})
export class NavbarComponent implements AfterViewInit {
  profile$: Observable<UserProfile | null>;
  screenAccess$: Observable<string[]>;
  @ViewChild('avatarHolder') avatarHolder!: ElementRef<HTMLDivElement>;
  @ViewChild('avatarInnerHolder', { static: false }) avatarInnerHolder!: ElementRef<HTMLDivElement>;

  settingsOpen: boolean = false;
  initialSettingsTab: string | undefined;
  private settingsSubscription: Subscription | undefined; // To manage subscription

  constructor(
    private authService: AuthService,
    private store: Store,
    private settingsOverlayService: SettingsOverlayService,
  ) {
    this.profile$ = this.store.select((state: any) => {
      return state.app.profile;
    });
    this.screenAccess$ = this.store.select((state: any) => state.app.screenAccessState);
  }

  showPopover = false;
  userName = '';
  userEmail = '';
  role: string = '';
  bottlerId: string = '';
  userPhone = 'No Contact Provided';
  avatar: null | string = null;
  userScreenAccess: string[] = [];
  isProduction: boolean = environment.production; 

  @Output() settingsSaved = new EventEmitter<void>();

  onSettingsSaved(): void {
    this.settingsSaved.emit();
  }

  ngOnInit(): void {
    this.settingsSubscription = this.settingsOverlayService.showSettings$.subscribe((show) => {
      this.settingsOpen = show;
    });

    this.settingsOverlayService.initialTab$.subscribe((tab) => {
      this.initialSettingsTab = tab;
    });
  }

  ngAfterViewInit(): void {
    this.profile$?.subscribe((profile: UserProfile | null) => {
      if (profile) {
        this.userName = profile.fullName;
        this.avatar = profile.avatar;
        this.userEmail = profile.emailAddress;
        this.role = profile.role ? profile.role : '';
        this.bottlerId = profile.bottlerId ? profile.bottlerId : '';
        const avatarInitials = createAvatar(this.userName);
        this.avatarHolder.nativeElement.appendChild(avatarInitials);
      }
    });
    this.screenAccess$.subscribe((screenAccess) => {
      console.log('Screen access in navbar:', screenAccess);
      this.userScreenAccess = screenAccess;
    });
  }

  closeSettings(item: boolean) {
    if (!item) {
      this.settingsOverlayService.closeSettings();
    }
  }

  togglePopover(event: Event) {
    this.showPopover = !this.showPopover;
    setTimeout(() => {
      if (this.avatarInnerHolder) {
        const avatarInitials = createAvatar(this.userName);
        avatarInitials.style.width = '68px';
        avatarInitials.style.height = '68px';
        avatarInitials.style.fontSize = '24px';
        this.avatarInnerHolder.nativeElement.appendChild(avatarInitials);
      } else {
        console.error('avatarInnerHolder is still undefined');
      }
    }, 100);
  }

  setResult(event: CustomEvent<OverlayEventDetail>) {
    // console.log(`Dismissed with role: ${event.detail.role}`);
  }

  closePopover() {
    this.showPopover = false;
  }

  async openSettings() {
    this.settingsOverlayService.openSettings();
    this.closePopover();
  }

  switchAccount() {
    // Handle account switch logic
    this.closePopover();
    // console.log('switch the account');
  }

  logout() {
    // Handle logout logic
    this.authService.logout();
    this.closePopover();
    // console.log('logout');
  }

  profileMenu() {
    // console.log('Opening Profile Menu');
  }

  supportMenu() {
    // console.log('Hi from support');
  }

  isVisible(): boolean {
    //it should be false only when the user have the only voids screen access and no RECS or ALL
    const hasOnlyVoidsAccess = this.userScreenAccess.includes('VOIDS') && !this.userScreenAccess.includes('RECS') && !this.userScreenAccess.includes('ALL');
    const isCona = sessionStorage.getItem('bottlerID') === 'CONA';
    return isCona || !hasOnlyVoidsAccess;
  }

  ngOnDestroy(): void {
    if (this.settingsSubscription) {
      this.settingsSubscription.unsubscribe();
    }
  }
}
